import {
  imprimirPdfsQz,
  listarImpressorasQz,
} from "@/modules/Restaurante/services/qzTrayPrinter";

export async function imprimirDocumentosPdv({
  tipo,
  id,
  urls,
  automatica,
  impressora,
  tentativas,
  imprimirManual,
}) {
  const documentos = urls.filter(Boolean);
  if (!automatica) {
    documentos.forEach(imprimirManual);
    return documentos;
  }
  if (!documentos.length) return documentos;

  const chave = `${tipo}:${id}`;
  if (tentativas.has(chave)) return documentos;
  tentativas.add(chave);

  if (!impressora) {
    throw new Error("Configure a impressora PDV / Caixa em Configurações Gerais > Impressões.");
  }
  const impressoras = await listarImpressorasQz();
  if (!impressoras.includes(impressora)) {
    throw new Error(`A impressora "${impressora}" não foi encontrada no QZ Tray.`);
  }
  await imprimirPdfsQz(impressora, documentos);
  return documentos;
}
